<template>
  <transition name="company">
    <v-alert
      border="left"
      rounded
      fixed
      colored-border
      :color="border"
      class="alert"
      :class="[styleClass]"
    >
      <span class="font-weight-medium">{{text}}</span>
    </v-alert>
  </transition>
</template>

<script>
export default {
  props: ["text", "styleClass", "border"]
};
</script>

<style>
.red-main {
  background: #FCE8E6 !important;
}
.alert {
  width: 85%;
  position: fixed !important;
  display: flex;
  align-items: center;
  top: 2%;
  justify-content: flex-start;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, 0%);
}

@media screen and (min-width: 1000px) {
  .alert {
    width: 43.4%;
  }
}

@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .alert {
    width: 58%;
  }
}

@media (max-width: 1024px) and (min-width: 768px) and (orientation: portrait) {
  .alert {
    width: 60% !important;
  }
}
</style>